<template>

  <div class="menu-container">
    <!-- root level itens -->
    <div>

    </div>
    <ul class="menu">

      <li class="menu__top" >
        <a
                href="/"
                @click.prevent="updateMenu('home')"
                class="menu__link menu__top_avoid_hover"
        >
          <img class="logo" src="../assets/escudo.png">
        </a>
      </li>
      <li>
        <a
                href="/"
                @click.prevent="updateMenu('home')"
                :class="highlightSection('home')"
        >
          <i class="fa fa-home menu__icon" aria-hidden="true"></i>
          Home

        </a>
      </li>
      <li>
        <a
          href="/products"
          @click.prevent="updateMenu('products')"
          :class="highlightSection('products')"
        >
          <i class="fa fa-cubes menu__icon" aria-hidden="true"></i>
          Productos

        </a>
      </li>

      <li>
        <a
          href="/orders"
          @click.prevent="updateMenu('orders')"
          :class="highlightSection('orders')"
        >
          <i class="fa fa fa-shopping-basket menu__icon" aria-hidden="true"></i>
          Pedidos

        </a>
      </li>

      <li>
        <a
                href="/"
                @click.prevent="logout('home')"
                class="menu__link logout_row"
        >
            <i class="fa fa-sign-out-alt menu__icon" aria-hidden="true"></i>
            Cerrar Sesion
        </a>
      </li>

    </ul>


    <!-- context menu: childs of root level itens -->
    <transition name="slide-fade">

      <div class="context-menu-container" v-show="showContextMenu">

        <ul class="context-menu">

          <li v-for="(item, index) in menuItens" :key="index">

            <h5 v-if="item.type === 'title'" class="context-menu__title">

              <i :class="item.icon" aria-hidden="true"></i>

              {{item.txt}}

              <a
              v-if="index === 0"
              @click.prevent="closeContextMenu"
              class="context-menu__btn-close"
              href="#"
              >
                <i class="fa fa-window-close" aria-hidden="true"></i>
              </a>

            </h5>

            <a
            v-else
            href="#"
            @click.prevent="openSection(item)"
            :class="subMenuClass(item.txt)"
            >
              {{item.txt}}
            </a>

          </li>

        </ul>

      </div>

    </transition>


  </div>

</template>

<script>
import menuData from './support/menu-data';
import kebabCase from 'lodash/kebabCase';
import { Auth } from '../firebase/auth';

export default {
  name: 'Menu',

  data(){
    return {
      contextSection: '',

      menuItens: [],

      menuData: menuData,

      activeSubMenu: ''
    }
  },

  methods: {

    updateMenu(context) {
      this.contextSection = context;
      this.menuItens = this.menuData[context];

      if (context === 'home') {
        this.$router.push('/');
        window.bus.$emit('menu/closeMobileMenu');
      }

      if (context === 'orders') {
        this.$router.push('/orders');
        window.bus.$emit('menu/closeMobileMenu');
      }

      if (context === 'products') {
        this.$router.push('/products');
        window.bus.$emit('menu/closeMobileMenu');
      }
    },

    highlightSection(section) {
      return {
        'menu__link': true,
        'menu__link--active': section === this.contextSection,
      };
    },

    subMenuClass(subMenuName) {
      return {
        'context-menu__link': true,
        'context-menu__link--active': this.activeSubMenu === subMenuName,
      };
    },

    closeContextMenu() {
      this.contextSection = '';
      this.menuItens = [];
    },

    openSection(item) {
      this.activeSubMenu = item.txt;

      this.$router.push(this.getUrl(item));
      window.bus.$emit('menu/closeMobileMenu');
    },

    getUrl(item) {
      let sectionSlug = kebabCase(item.txt);

      return `${item.link}/${sectionSlug}`;
    },

    logout(context){

      this.contextSection = context;
      this.menuItens = this.menuData[context];
      
      Auth.signOut()
      .then( () => {
        window.location.href = '/login';
      })
      .catch(error => {
        alert(error);
      }) 
    }

  },

  computed: {
    showContextMenu() {
      return this.menuItens.length;
    },
  }

}
</script>
